import type { TFunction } from "i18next";

import type { NotificationChannelCopyMap } from "~/lib/push-notifications";

/**
 * The push channels' names in the member's language, for every screen that may be the
 * one to ask for notification permission. Defined once, so what Android lists in the
 * app's settings does not depend on which screen happened to ask first.
 */
export function pushChannelCopy(t: TFunction): NotificationChannelCopyMap {
  return {
    chat: {
      name: t("profile.chat.notificationChannel"),
      description: t("profile.chat.notificationChannelDescription"),
    },
    eventReminders: {
      name: t("notifications.channel.eventReminders"),
      description: t("notifications.channel.eventRemindersDescription"),
    },
  };
}
